import * as React from "react";
import Checkbox from "../../hiberUiKit/src/atoms/Checkbox/Checkbox";

interface IProps {
	/**
	 * Indicates if checkbox is checked.
	 */
	checked: boolean;
	/**
	 * On change callback
	 */
	onChange: (value: boolean) => void;
}

export default class DayViewEngineersFilter extends React.Component<IProps, {}> {
	render() {
		return (
			<div className="c-day-view_engineers-filter">
				<Checkbox checked={this.props.checked} label={"Engineers with appointments only"}
						  onChange={this.props.onChange}/>
			</div>
		);
	}
}